<template>
  <div :class="{'device': device === 'mobile'}" class="ubiMainContPage">
    <div :class="{'en-top-tips': language === 'en'}" class="top-tips">
      {{ $t('ubi.topTipsTitle') }}
      <p>{{ $t('ubi.topTipsContent') }}</p>
    </div>
    <div class="custom-radio-group">
      <div :class="{active: trackType === ''}" class="custom-radio-item" @click="changeTrackType('')">{{ $t('trackingNo') }}</div>
      <div :class="{active: trackType === '0'}" class="custom-radio-item" @click="changeTrackType('0')">{{ $t('consignmentId') }}</div>
    </div>
    <SearchAndResults :options="options" :track-type="trackType" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SearchAndResults from './SearchAndResults/index.vue'
export default {
  components: {
    SearchAndResults
  },
  data() {
    return {
      trackType: '',
      options: {}
    }
  },
  computed: {
    ...mapGetters(['language', 'device'])
  },
  created() {
    let imgCnOrEn = this.language === 'zh' ? 'cn' : 'en'
    this.options = {
      contactUs: this.$t('ubi.contactUs'),
      btnBgi: require('@/assets/images/ubi/track_' + imgCnOrEn + '_blue.png'),
      btnBgiHover: require('@/assets/images/ubi/track_' + imgCnOrEn + '_yellow.png')
    }
  },
  mounted() {
    // 判断是否为移动端设备
    function isMobileDevice() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    }
    // 使用示例
    if (isMobileDevice()) {
      this.$store.dispatch('app/toggleDevice', 'mobile')
    } else {
      this.$store.dispatch('app/toggleDevice', 'desktop')
    }
  },
  methods: {
    changeTrackType(type) {
      this.trackType = type
    }
  }
}
</script>
<style lang='scss' scoped>
.ubiMainContPage {
  flex: 1;
  width: 1200px;
  &.device {
    width: 900px;
  }
  margin: 0 auto;
  .top-tips {
    padding-top: 60px;
    font-weight: bold;
    font-size: 42px;
    font-family: "Microsoft YaHei", SimHei, Helvetica, Arial, sans-serif;
    color: $menuActiveColor;
    text-align: center;
    p {
      color: #7DB9E8;
      font-size: 16px;
      margin: 15px 0 25px;
      font-weight: normal;
      font-family: "Microsoft YaHei", SimHei, Helvetica, Arial, sans-serif;
    }
    &.en-top-tips {
      font-family: $fontFamilyArialBoldMT;
      p {
        font-family: $fontFamilyArialMT;
      }
    }
  }
  .radio-type {
    text-align: left;
    padding-left: 178px;
    box-sizing: border-box;
    margin-bottom: 20px;
    /deep/.el-radio__input.is-checked .el-radio__inner {
      border-color: #023C7F;
      background: #023C7F;
    }
    /deep/.el-radio__input.is-checked+.el-radio__label {
      color: #023C7F;
    }
  }
  .custom-radio-group {
    display: flex;
    justify-content: center;
    padding-right: 170px;
    align-items: flex-end;
    height: 50px;
    .custom-radio-item {
      width: 140px;
      padding: 8px 0;
      font-size: 14px;
      text-align: center;
      background-color: $menuBgcBox2Blue;
      color: #fff;
      font-weight: bold;
      font-family: $fontFamilyArialBoldMT;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      cursor: pointer;
      &:nth-child(2) {
        background-color: $menuBgcOragne;
      }
      &.active {
        padding: 10px 0;
      }
    }
  }
}
</style>
